export const site_ip = "https://dbapi.respiratoryknowledgecentre.com/api";
